import { useEffect, useState } from 'react';
import {
  currentPlatform,
  isMobilePlatform,
  storeUrlForPlatform,
} from '../utilities/platform';
import '../css/OpenInApp.css';

// Keeps the iOS Smart App Banner pointing at this exact field (Safari reads
// the meta on page load, which is how shared links arrive), and offers an
// explicit "Open in the app" pill for everyone else. The button tries the
// app's custom URL scheme — registered on both platforms, iOS via
// CFBundleURLTypes and Android via the fieldfactsbaseball://fields intent
// filter — and if the app isn't installed the store link sits right next to
// it, pointing at the store that visitor can actually install from.
export const OpenInApp = ({ fieldId }) => {
  const [platform, setPlatform] = useState('other');

  useEffect(() => {
    const banner = document.querySelector('meta[name="apple-itunes-app"]');
    if (banner && fieldId) {
      banner.setAttribute(
        'content',
        `app-id=1352780085, app-argument=https://fieldfactsbaseball.com/fields/${fieldId}`,
      );
    }

    setPlatform(currentPlatform());
  }, [fieldId]);

  if (!isMobilePlatform(platform) || !fieldId) {
    return null;
  }

  return (
    <div className="ff-open-in-app">
      <a
        className="ff-button ff-button-gold"
        href={`fieldfactsbaseball://fields/${fieldId}`}
      >
        Open in the app
      </a>
      <a
        className="ff-open-in-app-store-link"
        href={storeUrlForPlatform(platform)}
      >
        Don&apos;t have it? Get Field Facts free
      </a>
    </div>
  );
};
